import React from 'react';

const Dashboard = () => {
  return <section>Comming Soon</section>;
};

export default Dashboard;
